const NavStrings = {
  HOME: "/",
  CLARIVIZBYBENFRANKLIN: "/about-us-clariviz-by-ben-franklin",
  LENSMANUFACTURINGUNIT: "/about-us-lens-manufacturing-unit",
  CONTACTUS: "/contact-us",
  STORELOCATOR: "/store-locator",
  CLARIVIZLENSES: "/clariviz-lenses",
  ZSERIESDS: "/clariviz-lenses/clariviz-z-series-ds",
  ZSERIES20: "/clariviz-lenses/clariviz-z-series-2.0",
  ZSERIES10: "/clariviz-lenses/clariviz-z-series-1.0",
  DIGIPRO20: "/clariviz-lenses/clariviz-digi-pro-2.0",
  DIGIPRO10: "/clariviz-lenses/clariviz-digi-pro-1.0",
  PROVIEW20: "/clariviz-lenses/clariviz-pro-view-2.0",
  PROVIEW10: "/clariviz-lenses/clariviz-pro-view-1.0",
  CLEARDRIVEPAL: "/clariviz-lenses/clariviz-clear-drive-pal",
  CLARIVIZOFFICE: "/clariviz-lenses/clariviz-office",
  PIXELDIGI: "/clariviz-lenses/pixel-digi",
  QUICHROMES: "/clariviz-lenses/clariviz-quichromes",
  CLARIVIZSINGLEVISION: "/clariviz-lenses/clariviz-single-vision",
  CLEARDRIVESV: "/clariviz-lenses/clariviz-clear-drive-sv",
  RXBIFOCAL: "/clariviz-lenses/clariviz-rx-bi-focal",
  BENDIGITALPAL: "/clariviz-lenses/ben-digital-pals",
  LENSTECHNOLOGIES: "/clariviz-lenses/lens-technologies",
  ULTIPROUVCOATING: "/lens-coating/ultiprouv-coating",
  ULTIPROBLUECOATING: "/lens-coating/ultipro-blue-coating",
  HERCUECOATING: "/lens-coating/hercue-coating",
  LENSCOLOUR: "/clariviz-lenses/lens-colour",
  LENSPERSONALIZATION: "/clariviz-lenses/lens-personalization",
  PRIVACYPOLICY: "/privacy-policy",
  COOKIEPOLICY: "/cookie-policy",
  CAREERS: "/careers",
};

export default NavStrings;
